import React, { FC, ReactNode } from "react";
import {
  FormControl,
  FormHelperText,
  FormLabel,
  Option,
  Select,
  Typography,
} from "@mui/joy";
import { FieldError } from "react-hook-form";

type PhoneInputProps = {
  label?: string;
  options: { label: string; value: string }[];
  value: string;
  error?: FieldError;
  onChange?: (value: string) => void;
  endDecorator?: ReactNode;
  readOnly?: boolean;
  required?: boolean;
};

export const SelectInput: FC<PhoneInputProps> = (props) => {
  const {
    label,
    options,
    value,
    error,
    onChange,
    endDecorator,
    readOnly,
    required,
  } = props;

  return (
    <FormControl error={!!error}>
      {label ? (
        <FormLabel>
          {label}
          {required ? <Typography color="danger">*</Typography> : null}
        </FormLabel>
      ) : null}
      <Select
        placeholder="Select"
        variant="soft"
        size="lg"
        value={value}
        onChange={(e, data) => {
          onChange(data);
        }}
        endDecorator={endDecorator}
        disabled={readOnly}
      >
        {options.map((option) => (
          <Option value={option.value} key={`select-input-${option.value}`}>
            {option.label}
          </Option>
        ))}
      </Select>
      {error ? <FormHelperText>{error.message}</FormHelperText> : null}
    </FormControl>
  );
};
